// extracted by mini-css-extract-plugin
export var askAiIcon = "_m1-9";
export var container = "_m1-0";
export var groupSeparator = "_m1-a";
export var highlight = "_m1-4";
export var resultIcon = "_m1-5";
export var resultItem = "_m1-7";
export var resultSubtitle = "_m1-3";
export var resultTitle = "_m1-2";
export var resultsList = "_m1-1";
export var searchGroup = "_m1-6";
export var selected = "_m1-8";